// Exports the "bbcode" plugin for usage with module loaders
// Usage:
//   CommonJS:
//     require('tinymce/plugins/bbcode')
//   ES2015:
//     import 'tinymce/plugins/bbcode'
require('./plugin.js');


// WEBPACK FOOTER //
// ./src/packages/tinymce/plugins/bbcode/index.js